import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';
import { decodeDDI, encodeDDI } from '../utils';

export class DataLogValueEntity implements Entity {
  public static fromXML(xml) {
    const attrs = xml._attributes;

    return {
      entity: new DataLogValueEntity(
        decodeDDI(attrs[ATTRS.DataLogValue.ProcessDataDDI]),
        attrs[ATTRS.DataLogValue.ProcessDataValue],
        attrs[ATTRS.DataLogValue.DeviceElementIdRef],
        attrs[ATTRS.DataLogValue.DataLogPGN],
        attrs[ATTRS.DataLogValue.DataLogPGNStartBit],
        attrs[ATTRS.DataLogValue.DataLogPGNStopBit]
      ),
    };
  }
  public type = TAGS.DataLogValue;

  constructor(
    public DDI: number,
    public value: number,
    public deviceElementIdRef: string,
    public dataLogPGN?: number,
    public dataLogPGNStartBit?: number,
    public dataLogPGNStopBit?: number
  ) {}

  public toXML() {
    return {
      _attributes: {
        [ATTRS.DataLogValue.ProcessDataDDI]: encodeDDI(this.DDI),
        [ATTRS.DataLogValue.ProcessDataValue]: this.value,
        [ATTRS.DataLogValue.DeviceElementIdRef]: this.deviceElementIdRef,
        [ATTRS.DataLogValue.DataLogPGN]: this.dataLogPGN,
        [ATTRS.DataLogValue.DataLogPGNStartBit]: this.dataLogPGNStartBit,
        [ATTRS.DataLogValue.DataLogPGNStopBit]: this.dataLogPGNStopBit,
      },
    };
  }
}
